import { getWebsiteNewConfigurePath } from 'domains/website/website.paths'

export const getTemplateDeploymentLink = (
  templateGitRepoUrl: string,
  templateSlug: string,
  accountSlug?: string
) => ({
  pathname: getWebsiteNewConfigurePath(accountSlug, true),
  query: {
    source: templateGitRepoUrl,
    template: templateSlug
  }
})

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const buildURL = (baseUrl: string, query?: Record<string, any>) => {
  const url = new URL(baseUrl)
  if (query) {
    url.search = new URLSearchParams(query).toString()
  }
  return url.toString()
}

export const openInNewTab = (url: string) => open(url, '_blank')?.focus()

export const getGraphqlEndpoint = (url: string): string => {
  const baseUrl = url.replace(/(http(s)?:\/\/)|(\/.*){1}/g, '')
  return `https://${baseUrl}/graphql`
}
